import { Box, Typography } from '@mui/material';

const Evidence = ({ evidence, notes }) => (
  <Box component="footer" sx={{ mt: 5, pt: 2, borderTop: '1px solid rgba(255,255,255,0.14)' }}>
    {evidence?.length > 0 && (
      <>
        <Typography variant="h2" sx={{ fontSize: 16, fontWeight: 700 }}>
          Where these ratings come from
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, my: 1, fontSize: 13, opacity: 0.85 }}>
          {evidence.map((item, index) => (
            <li key={item.id || `evidence-${index}`}>{item.label}</li>
          ))}
        </Box>
      </>
    )}
    {notes?.map((note, index) => (
      <Typography key={`${index}-${note}`} sx={{ fontSize: 13, opacity: 0.85 }}>
        {note}
      </Typography>
    ))}
    <Typography sx={{ mt: 1, fontSize: 12, opacity: 0.7 }}>
      General fitness guidance for the game, not medical advice. Ratings compare you with your own
      history. Talk to a professional before changing your training if you have health concerns.
    </Typography>
  </Box>
);

export default Evidence;
